import { inject, Injectable, Injector } from "@angular/core";
import {
  ActivatedRoute,
  NavigationStart,
  NavigationEnd,
  Router,
  Event,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import { catchError, map, retry } from "rxjs/operators";
import { UrlPhpApi } from "./auth/services/models";
import { environment } from "@env/environment";
import { PictureGeneratingPipeline } from "./core/pipes/core.pipe";
import { TokenService } from "./auth/services/token.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "./shared/services/language.service";

export type Language = {
  code: string;
  name: string;
};

@Injectable()
export class AppService {
  private tokenService = inject(TokenService);

  public url_route: string = "";
  public url_Base: string = environment.mainDomain;
  public url_affiliate: string = environment.urlAPI;
  // public url_Base: string = "https://develop.edutin.com";
  public url_previous: string;
  public show_desktop_notification: boolean = false;
  public display_spinner: boolean = false;
  private _displayAnimation: boolean = false;

  get displayAnimation(): boolean {
    return this._displayAnimation;
  }

  set displayAnimation(value: boolean) {
    this._displayAnimation = value;
    document.body.classList.toggle("splash-no-scroll", value);
  }

  baseUrl = this.url_Base + "/libraries/myLibrary";
  // baseLambdaUrl = 'https://api.edutin.com/b/d';
  baseLambdaUrl = environment.urlAPI;
  baseRetry: number = 1;

  public token: string;
  static idtoken: string;
  nextToken: String = null;

  public verifyEmail = {
    detail: null,
    type: null,
  };

  public user_country_id;

  public authenticated_error: string;

  public loadNavBar: boolean = false;
  public loadFooter: boolean = false;

  public indexedDB_users_list;

  public showMessaging: boolean = false;

  public resultSearch: boolean = false;

  public scrollSubject: Subject<any> = new Subject<any>();

  private _langService = inject(LanguageService);

  public languages: Record<string, Language> = {
    br: { code: "pt", name: "Portugués" },
    pt: { code: "pt", name: "Portugués" },
  };

  public languages_links: Record<string, Language> = {
    pt: { code: "br", name: "Portugués" },
    es: { code: "",   name: "Español" }
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private _translate: TranslateService,
  ) {
    let routerEventsSubscriber = this.router.events.subscribe(
      (routerEvent: Event) => {
        if (routerEvent instanceof NavigationStart) {
          this.display_spinner = true;
        }

        if (
          routerEvent instanceof NavigationEnd ||
          routerEvent instanceof NavigationError ||
          routerEvent instanceof NavigationCancel
        ) {
          this.display_spinner = false;
          if (routerEventsSubscriber) routerEventsSubscriber.unsubscribe();
        }
      },
    );

    this._langService.languageChange$.subscribe(() => {
      this.getCategory(this.user_session === 1).subscribe();
    });
  }

  public comment_modal_ = {
    data: null,
    state: false,
  };

  public certification: any;
  public config = {
    actions: false, //si el usuario está logueado ? true : false
  };

  public display_navbar: boolean = true;
  public isDesktop: boolean = true;
  menu_is_active: boolean = false;
  public hoverTop(ev?) {
    if (this.url_route == "classroom") {
      this.menu_is_active = ev != null ? ev : false;

      if (!this.display_navbar) {
        this.display_navbar = true;
        // setTimeout(() => {
        if (!this.menu_is_active) this.display_navbar = false;
        // }, 500);
      } else {
        // setTimeout(() => {
        if (!this.menu_is_active) this.display_navbar = false;
        // }, 500);
      }
    }
  }

  getHeaders(): any {
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.tokenService.getToken(),
    });

    return { headers: headers };
  }

  post(url: any, formData: FormData) {
    return this.http.post(url, formData, this.getHeaders());
  }

  put(url: any, formData: FormData) {
    return this.http.put(url, formData, this.getHeaders());
  }

  delete(url: any) {
    return this.http.delete(url, this.getHeaders());
  }

  public user_data: any;
  public user_session: number = -1;

  activeSplash() {
    this.displayAnimation = true;

    setTimeout(() => {
      this.displayAnimation = false;
    }, 2800);
  }

  getUserData() {
    const { dataUserAuthenticated, user_data, user_session } = this;
    if (!dataUserAuthenticated) {
      return { valid: false, print: null, session: user_session };
    }

    return {
      valid: true,
      print: user_data ?? null,
      session: user_session,
    };
  }

  public dataUserAuthenticated;
  public display_verification_alert: boolean = false; //Cuando es verdadero muestra la notificación de verificación de correo electrónico
  public userSignUpEmail;
  setUserData(UserData, from?) {
    this.dataUserAuthenticated = UserData;
    // let response;
    if (
      typeof this.dataUserAuthenticated === "object" &&
      this.dataUserAuthenticated?.id
    ) {
      // User with session
      this.user_session = 1;
      UserData.picture =
        PictureGeneratingPipeline.prototype.transform(UserData);
      this.user_data = UserData;
      if (
        UserData.hasOwnProperty("certification_id") &&
        UserData.certification_id == "0"
      ) {
        const ls_certification_id = localStorage.getItem(
          "last-certificate-default",
        );
        if (ls_certification_id) {
          this.user_data.certification_id = ls_certification_id;
        }
      }

      this.getUserDataDB(UserData.id, "role").subscribe((resp) => {
        const { print, valid } = resp;
        if (valid) {
          // const { role } = print;
          // this.user_data.role = role;
          this.user_data = { ...this.user_data, ...print };
        }
      });
    } else {
      this.token = null;
      // User without session
      this.user_session = 0;
      this.user_data = [];
      // response = { valid: true, print: [] };
    }
  }

  getUserDataDB(user_id, data_type): Observable<any> {
    const url = `${environment.urlAPI}/users/${user_id}`;
    // const endPoint = data_type == 'role' ? `${url}?fields=["role"]` : `${url}?fields=["certification_id"]`;
    // const endPoint = `${ environment.urlAPI }/users/${ user_id } `;
    const endPoint =
      data_type == "role"
        ? `${url}?fields=["user_role", "business_role", "country_id", "user_image"]`
        : `${url}?fields=["certification_id"]`;
    return this.http.get(endPoint).pipe(
      map((response: any) => {
        // Validar datos
        const valData = this.valData(2, response);
        const { data, metadata } = response;
        if (valData.is) {
          if (data?.length > 0) {
            if (data[0]?.Country[0]?.id == 1) {
              this.updateUserCountryId();
            }

            return { valid: true, print: data[0]?.User };
          }
          return { valid: false, print: "Answer without data" };
        } else {
          return { valid: false, print: valData?.msg };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUserDataDB", [])),
    );
  }

  updateUserCountryId() {
    // Actualizar el id del país del usuario si es INTERNATIONAL
    // Realiza una solicitud GET para obtener el ID de país del usuario
    this.http
      .get(`${environment.domain}/users/getIdCountry`)
      .pipe(
        // Mapea la respuesta para manejar los datos
        map((response: any) => {
          // Verifica si se obtuvo un country_id válido
          if (response?.country_id) {
            // Llama a putUser para actualizar el país del usuario
            const data = { country_id: response.country_id };
            this.putUser({ data }).subscribe((resp: any) => {
              // Si la actualización fue exitosa, actualiza los datos locales del usuario
              if (resp.valid) {
                this.user_data.country_id = response.country_id;
                if (this.dataUserAuthenticated) {
                  this.dataUserAuthenticated.country_id = response.country_id;
                }
              }
            });
          }
        }),
        // Reintenta la petición hasta 3 veces si ocurre un error
        retry(3),
      )
      .subscribe({
        // Suscripción necesaria para ejecutar el Observable
        next: () => {}, // El `next` ya lo manejas dentro del `map`
        error: (err) => console.error("Error al obtener country_id", err),
      });
  }

  popUpData: any = {};
  public reloadGetsNavBar: boolean = true;
  public startGetsNavBar() {
    return new Promise((resolve) => {
      // Get user data

      const userData = this.getUserData();
      if (userData.valid && this.reloadGetsNavBar) {
        // init app
        resolve(true); // Start the validations of the routes
        if (this.user_session == 1) {
          // User with session
          // Get learning

          // Get category in nav-bar
          if (this.categories.length == 0) {
            this.getCategory(true).subscribe();
          }
        } else if (this.user_session == 0) {
          // User without session
          // Get category in nav-bar
          if (this.categories.length == 0) {
            this.getCategory(false).subscribe();
          }
        }
        this.reloadGetsNavBar = false;
        // window.addEventListener("storage", this.changeStorage, false);
      } else {
        resolve(false);
      }
    });
  }

  lazyEventStream = new Subject();
  lazyConversationsStream = new Subject();

  isFirstTime = true;

  public defaultGetsNavBar() {
    this.user_data = undefined;
    this.user_session = -1;

    this.categories = [];

    this.reloadGetsNavBar = true;
  }

  changeStorage(e) {
    if (e.key == "token") {
      let url = new URL(window.location.href);
      if (url.searchParams.get("token") != null) {
        this.token = url.searchParams.get("token");
        localStorage.setItem("token", this.token);
      } else if (localStorage.getItem("token") != null) {
        if (e.oldValue == e.newValue) {
          this.token = localStorage.getItem("token");
        } else {
          sessionStorage.clear();
          window.location.href = "https://edutin.com/";
        }
      } else {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "https://edutin.com/users/login";
      }
    }
  }

  public dateCertification(fecha_inscripcion: string): any {
    let date, date_state;
    let fecha = new Date(fecha_inscripcion.replace(/\s/, "T"));
    let limit = new Date("2019-11-01");
    let hoy = new Date();
    if (fecha < limit) {
      fecha = limit;
    }
    fecha.setDate(fecha.getDate() + 7);
    // fecha.setMonth(fecha.getMonth() + 1);
    if (fecha < hoy) {
      date_state = false;
    } else {
      date_state = true;
    }
    const monthNames = this._translate.instant("DATES.MONTHS_SHORT").split(",");
    date =
      fecha.getDate() +
      " " +
      monthNames[fecha.getMonth()] +
      " " +
      fecha.getFullYear();
    return { date, date_state };
  }

  getCategoryInfo(category_id): Observable<any> {
    return this.http
      .get(
        this.baseLambdaUrl +
          "/categories/" +
          category_id +
          "?language=" +
          this._langService.currentLanguageId,
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        retry(this.baseRetry),
        catchError(this.handleError<any>("getCategoryInfo", [])),
      );
  }

  categories: Array<any> = [];
  loadingCategories: boolean = false;
  categoriesSubject: Subject<any> = new Subject<any>();
  categories$ = new BehaviorSubject<any[]>([]);
  getCategory(type: boolean = false): Observable<any> {
    this.loadingCategories = true;
    return this.http
      .get(
        this.baseLambdaUrl +
          "/categories" +
          (type ? "/custom" : "") +
          (this._langService.currentLanguageId !== 1
            ? "?language_id=" + this._langService.currentLanguageId
            : ""),
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            if (response.data.length > 0) {
              this.categories = response.data;
              this.categoriesSubject.next(response.data);
              this.categories$.next(response.data);
            }
            this.loadingCategories = false;
            return { valid: true, print: response.data };
          } else {
            this.categories = [];
            this.loadingCategories = false;
            this.categories$.next([]);
            return { valid: false, print: valData.msg };
          }
        }),
        retry(this.baseRetry),
        catchError(this.handleError<any>("getCategory", [])),
      );
  }

  getCampaignsInfo(campaing_id): Observable<any> {
    return this.http
      .get(
        this.baseLambdaUrl +
          "/campaings/" +
          campaing_id +
          "?language=" +
          this._langService.currentLanguageId,
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        retry(this.baseRetry),
        catchError(this.handleError<any>("getCampaignsInfo", [])),
      );
  }

  campaigns: Array<any> = [];
  getCampaigns(category_id): Observable<any> {
    return this.http
      .get(
        this.baseLambdaUrl +
          "/campaings?category_id=" +
          category_id +
          "&language=" +
          this._langService.currentLanguageId,
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        retry(this.baseRetry),
        catchError(this.handleError<any>("getCampaigns", [])),
      );
  }

  public user_ip;
  getUserCountry(): Observable<any> {
    const country_id = localStorage.getItem("user_country");
    const user_ip = localStorage.getItem("user_ip");

    // Si están almacenados no hacer la petición
    if ((user_ip && country_id) || this.user_country_id || this.user_ip) {
      this.user_country_id = this.user_country_id ?? country_id;
      this.user_ip = this.user_ip ?? user_ip;
      return new Observable((observer) => observer.next(this.user_country_id));
    }

    return this.http.get(`${UrlPhpApi}/users/getIdCountry`).pipe(
      map((response: any) => {
        if (response?.country_id) {
          this.user_country_id = response.country_id;
          localStorage.setItem("user_country", response.country_id);
        }

        if (response?.ip) {
          this.user_ip = response.ip;
          localStorage.setItem("user_ip", response.ip);
        }

        return response.country_id;
      }),
      retry(3),
    );
  }

  getCourseInfo(courseId): Observable<any> {
    const fields = [
      "id",
      "nombre",
      "slug",
      "descripcion",
      "tematicas",
      "visitas",
      "language_id",
    ];
    return this.http
      .get(
        this.baseLambdaUrl +
          "/cursos/" +
          courseId +
          "?fields=" +
          JSON.stringify(fields),
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        catchError(this.handleError<any>("getCourseInfo", [])),
      );
  }

  enrollUser(body): Observable<any> {
    return this.post(this.baseLambdaUrl + "/certifications", body).pipe(
      map((response: any) => {
        // Validar datos
        let valData = this.valData(2, response);
        if (valData.is) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: valData.msg };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("setRanking", [])),
    );
  }

  getCourseTab(curso_id, type): Observable<any> {
    return this.http
      .get(
        this.relativeUrl +
          "/get_server_data.json?curso_id=" +
          curso_id +
          "&option=" +
          type,
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(0, { x: response });
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        catchError(this.handleError<any>("getCourseTab", [])),
      );
  }

  setRanking(json): Observable<any> {
    return this.post(this.relativeUrl + "/ranking_add.json", json).pipe(
      map((response: any) => {
        // Validar datos
        let valData = this.valData(0, { x: response });
        if (valData.is) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: valData.msg };
        }
      }),
      catchError(this.handleError<any>("setRanking", [])),
    );
  }

  openCourse(course): void {
    if (course && course.hasOwnProperty("id")) {
      let config = {
        curso_id: course.id,
        certification_id: course.certification_id,
        type: course.tipo,
        clase_id: course.clase_id,
        idu: this.user_data.id,
        source_id: course.source_id,
        quiz_id: course.quiz_id,
        language_id: course.language_id,
        state: course.certification_state,
        tour: course.certification_tour,
      };

      sessionStorage.setItem("config", JSON.stringify(config));
      this.router.navigateByUrl("/classroom?config=" + JSON.stringify(config));
    }
  }

  searchText: string = "";
  getResultSearch(
    text,
    start,
    last_item?,
    languageId?: number,
    data?: any
  ): Observable<any> {
    let url =
      this.url_affiliate +
      '/cursos/search?search_string="' +
      text +
      '"&start=' +
      start;
    if (last_item) {
      url += "&last_item=" + JSON.stringify(last_item);
    }
    if (languageId) {
      url += "&languages=" + encodeURIComponent(JSON.stringify([languageId]));
    }

    let params = new HttpParams()

    if(data){
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== undefined) {
          params = params.set(key, data[key]);
        }
      })
    }

    return this.http.get(url, { params }).pipe(
      map((response: any) => {
        if (response.status) {
          this.resultSearch = response.data;
          return {
            valid: true,
            print: response.data,
          };
        } else {
          return { valid: false, print: "not found" };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getResultSearch", [])),
    );
  }

  deleteNotification(id): Observable<any> {
    return this.delete(this.baseLambdaUrl + "/notifications/" + id).pipe(
      map((response: any) => {
        return response;
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("deleteNotification", [])),
    );
  }

  updateSubscriptionOnServer(json): Observable<any> {
    return this.post(
      this.baseLambdaUrl +
        "/users/" +
        this.user_data.id +
        "/notifications/subscriptions",
      json,
    ).pipe(
      map((response: any) => {
        // Validar datos
        let valData = this.valData(2, response);
        if (valData.is) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: valData.msg };
        }
      }),
      catchError(this.handleError<any>("updateSubscriptionOnServer", [])),
    );
  }

  unit: Array<any> = [];
  getUnit(courseId): Observable<any> {
    return this.http
      .get(
        this.baseLambdaUrl + "/cursos/" + courseId + "/modules",
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(2, response);
          if (valData.is) {
            return { valid: true, print: response.data };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        retry(this.baseRetry),
        catchError(this.handleError<any>("getUnit", [])),
      );
  }

  putUser(body): Observable<any> {
    return this.put(
      this.baseLambdaUrl + "/users/" + this.user_data.id,
      body,
    ).pipe(
      map((response: any) => {
        // Validar datos
        let valData = this.valData(2, response);
        if (
          valData.is ||
          (response.hasOwnProperty("status") && response.status)
        ) {
          return { valid: true, print: response.data };
        } else {
          return { valid: false, print: valData.msg };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUnit", [])),
    );
  }

  isJsonString(strJson: string): boolean {
    // Validar JSON
    try {
      JSON.parse(strJson);
    } catch (e) {
      return false;
    }
    return true;
  }

  isError(resData: any, errorName: string): any {
    // Validar datos de JSON, Error...
    if (this.isJsonString(JSON.stringify(resData))) {
      if (resData == null || resData == undefined) {
        return { is: false, msg: "Answer with error" };
      } else if (resData instanceof Array) {
        return { is: true, msg: "Ok Array" };
      } else if (resData.hasOwnProperty("data")) {
        if (resData.data == null || resData.data == undefined) {
          return { is: false, msg: "Answer with error" };
        } else if (resData.data instanceof Array) {
          return { is: true, msg: "Ok Array" };
        } else if (resData.data.hasOwnProperty("Status")) {
          if (resData.data.Status == false) {
            localStorage.clear();
            sessionStorage.clear();
            // window.location.href = this.url_Base + "/users/login";
            return { is: false, msg: "Answer with error" };
          } else {
            return { is: true, msg: "Ok Value" };
          }
        } else {
          return { is: true, msg: "Ok Value" };
        }
      } else {
        return { is: true, msg: "Ok Value" };
      }
    } else {
      return { is: false, msg: "Invalid json response" };
    }
  }

  isErrorLambda(resData: any): any {
    if (this.isJsonString(JSON.stringify(resData))) {
      if (resData == null || resData == undefined) {
        return { is: false, msg: "Respond with null or undefined" };
      } else if (resData.hasOwnProperty("status")) {
        if (resData.status) {
          if (resData.hasOwnProperty("data")) {
            return { is: true, msg: "Ok Value" };
          } else {
            return {
              is: false,
              msg: "Response does not contain the [data] property",
            };
          }
        } else {
          return {
            is: false,
            msg: "Response contains false value in [status] property",
          };
        }
      } else {
        return {
          is: false,
          msg: "Response does not contain the [status] property",
        };
      }
    } else {
      return { is: false, msg: "Response does not contain a valid json" };
    }
  }

  valData(type: number, params: any): any {
    switch (type) {
      case 0:
        // Default
        return this.isError(params.x, "Error");
      case 1:
        return this.isError(params.x, params.y);
      case 2:
        return this.isErrorLambda(params);
      default:
        return {
          is: false,
          msg: "Invalid parameter type:(" + type + ") in valData",
        };
    }
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.log(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  private log(message: string) {
    // console.log(`ClassroomService: ${message}`);
  }

  relativeUrl = this.url_Base + "/libraries/myLibrary";
  getCourseToRedirect(comment_id): Observable<any> {
    // http://34.224.84.165/apis/learn/go_to_comments.json?comment_id=
    return this.http
      .get(
        "https://edutin.com/apis/learn/go_to_comments.json?comment_id=" +
          comment_id,
        this.getHeaders(),
      )
      .pipe(
        map((response: any) => {
          // Validar datos
          let valData = this.valData(0, { x: response });
          if (valData.is) {
            return { valid: true, print: response.data, id: comment_id };
          } else {
            return { valid: false, print: valData.msg };
          }
        }),
        catchError(this.handleError<any>("_getCourseToRedirect", [])),
      );
  }

  goToApp() {
    //console.log('goToApp')
    const { certification_id } = this.user_data;

    let init = sessionStorage.getItem("init");

    if (init == null) {
      if (certification_id != null && certification_id != "") {
      } else {
        // return this.router.navigate(['/category']);
      }
    }
  }
}
